<template>
	<div class="CommodityAdd">
		<div class="commodTitle">请选择需发布的商品类型</div>
		<div class="commodList">
			<div class="commodItem" @click="addCommodity(item.url)"
				:style="{ backgroundImage: 'url(' + item.bgIMG + ')', backgroundSize: '100% 100%'}"
				v-for="(item, i) in storeType" :key="i">{{ item.name }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "CommodityAdd",
	components: {},
	data() {
		return {
			storeType: [
				{ name: '影像数据', url: 'BasicData', bgIMG: require("../../../assets/imgs/img1.png") },
				{ name: '数据产品', url: 'DataProducts', bgIMG: require("../../../assets/imgs/img2.png") },
				{ name: '软件产品', url: 'softwareTool', bgIMG: require("../../../assets/imgs/img3.png") },
				{ name: '其他产品', url: 'OtherProduct', bgIMG: require("../../../assets/imgs/img1.png") },
			],
		}
	},
	mounted() {
		if (this.$route.query.Goodtype) {
			if (this.$route.query.Goodtype == 1) {
				this.$router.push({
					name: 'SellerCenter',
					query: {
						type: 'BasicData',
						id: this.$route.query.id,
					}
				})
			} else if (this.$route.query.Goodtype == 2) {
				this.$router.push({
					name: 'SellerCenter',
					query: {
						type: 'DataProducts',
						id: this.$route.query.id,
					}
				})
			} else if (this.$route.query.Goodtype == 3) {
				this.$router.push({
					name: 'SellerCenter',
					query: {
						type: 'softwareTool',
						id: this.$route.query.id,
					}
				})
			} else if (this.$route.query.Goodtype == 4) {
				this.$router.push({
					name: 'SellerCenter',
					query: {
						type: 'OtherProduct',
						id: this.$route.query.id,
					}
				})
			}
		}

	},
	methods: {
		addCommodity(url) {
			this.$router.push({
				name: 'SellerCenter',
				query: {
					type: url
				}
			})
		}
	},
};
</script>

<style lang="scss" scoped>
.CommodityAdd {
	padding: 10vh 0 0 0;
	text-align: center;
	font-weight: 700;
	color: rgb(112, 111, 111);

	.commodTitle {
		line-height: 15vh;
		font-size: 30px;

	}

	.commodList {
		display: flex;
		margin: 30px auto;
		justify-content: center;
		color: #fff;

		.commodItem {
			border: 1px solid #eee;
			padding: 20px 80px;
			margin-right: 60px;
			border-radius: 5px;
			font-size: 24px;
			cursor: pointer;
		}
	}
}
</style>